import React from "react";
import styles from "./number-stepper-field.module.scss";

interface NumberStepperFieldProps {
	value?: string;
	onChange: (value: string) => void;
	placeholder?: string;
	min?: number;
	max?: number;
	disabled?: boolean;
	hasError?: boolean;
}

const NumberStepperField: React.FC<NumberStepperFieldProps> = ({
	value = "",
	onChange,
	placeholder,
	min,
	max,
	disabled = false,
	hasError = false,
}) => {
	const step = (delta: number) => {
		const current = parseFloat(value);
		const next = (isNaN(current) ? 0 : current) + delta;
		onChange(String(next));
	};

	return (
		<div className={styles.row}>
			<input
				className={`${styles.field} ${hasError ? styles.error : ""}`}
				type="number"
				value={value}
				placeholder={placeholder}
				min={min}
				max={max}
				disabled={disabled}
				onChange={e => onChange(e.target.value)}
			/>
			<div className={styles.stepper}>
				<button type="button" className={styles.stepButton} onClick={() => step(-1)} disabled={disabled} aria-label="Decrease">
					−
				</button>
				<span className={styles.stepDivider} />
				<button type="button" className={styles.stepButton} onClick={() => step(1)} disabled={disabled} aria-label="Increase">
					+
				</button>
			</div>
			<button type="button" className={styles.clearButton} onClick={() => onChange("")} disabled={disabled}>
				Clear
			</button>
		</div>
	);
};

export default NumberStepperField;
